import { render, staticRenderFns } from "./GridPhase.vue?vue&type=template&id=4b180f6c&scoped=true&"
import script from "./GridPhase.vue?vue&type=script&lang=js&"
export * from "./GridPhase.vue?vue&type=script&lang=js&"
import style0 from "./GridPhase.vue?vue&type=style&index=0&id=4b180f6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b180f6c",
  null
  
)

export default component.exports